module.exports = __webpack_public_path__ + "img/feature9.3c7d10b.png";